/** Business names only: labels do not imply a different executor or migrated job. */
export const WORKFLOW_LABELS = {
  'account_deletion.erasure_requested': 'Account deletion',
  'commerce.broadway_catalog_sync_requested': 'Shopping catalog sync',
  'commerce.broadway_order_placement_requested': 'Shopping order placement',
  'commerce.cart_curation_requested': 'Shopping cart suggestions',
  'consumer.avatar_enhance': 'Profile photo enhancement',
  'consumer.studio_history_normalize': 'Studio conversation cleanup',
  'consumer.studio_reference_process': 'Studio garment photo processing',
  'consumer.twin': 'Digital twin generation',
  garment_ingestion: 'Garment processing',
  'interaction.chat.proactive': 'Proactive styling message',
  'interaction.notification.deliver': 'Member notification delivery',
  'interaction.notification.receipt': 'Notification delivery confirmation',
  'legacy.garment_batch_delivery_requested': 'Garment batch completion',
  'legacy.garment_variations_requested': 'Garment image variations',
  'legacy.stylist_notification': 'Stylist notification delivery',
  'legacy_outfit.title': 'Outfit titles',
  'legacy_outfit.dislike_replenishment': 'Replacement outfit suggestions',
  'legacy_outfit.stylist_replace': 'Stylist outfit replacement',
  'legacy_outfit.try_on': 'Outfit try-on image',
  'legacy_profile.deliver_notification': 'Member notification delivery',
  'legacy_profile.process_export': 'Member data export',
  'legacy_profile.reconcile_notification_receipt': 'Notification delivery confirmation',
  'member.what_i_wore_detection_requested': 'Worn garment detection',
  'onboarding.abandonment_reminder': 'Onboarding reminder',
  'onboarding.color_analysis': 'Personal colour analysis',
  outfit_generation: 'Outfit generation',
  'privacy_export.cleanup': 'Expired export cleanup',
  'privacy_export.process': 'Member data export',
  'purchase_validation.assess': 'Purchase suitability check',
  styling_recommendation: 'Outfit recommendations',
  'stylist.notification_delivery_requested': 'Stylist notification delivery',
  'stylist.wardrobe_gap_suggestion_requested': 'Wardrobe gap suggestions',
  'validation_graph.process': 'Outfit and cart suitability check',
  'wardrobe.garment_pairing_generation_requested': 'Pairs best with',
  'wardrobe.garment_uploaded': 'Garment upload',
  wardrobe_bulk_import: 'Wardrobe import',
  wardrobe_search_index: 'Wardrobe search indexing',
} as const satisfies Record<string, string>;

export function workflowLabel(family: string | undefined): string {
  return family ? (WORKFLOW_LABELS[family as keyof typeof WORKFLOW_LABELS] ?? family) : 'Unknown';
}
